import * as yup from 'yup';
import moment from 'moment';
import i18n from '../../translation/config';

const ConsumptionsReportForm = () =>
  yup.object().shape({
    commerceIds: yup
      .array()
      .of(yup.string())
      .min(1, i18n.t('select-at-least-one-commerce'))
      .required(i18n.t('select-at-least-one-commerce')),
    dateFrom: yup.date().required(i18n.t('start-date-required')),
    dateTo: yup
      .date()
      .when(
        'dateFrom',
        (dateFrom, schema) =>
          dateFrom && schema.min(moment(dateFrom).add(1, 'minute'), i18n.t('end-date-must-be-greater-than-start-date')),
      )
      .required(i18n.t('end-date-required')),
  });

export default ConsumptionsReportForm;
